export const styles = {
  wrapper: {
    position: 'relative',
    zIndex: 20,
    '.nav-container': {
      bg: 'white',
      position: 'fixed',
      transition: 'all 250ms ease-in',
      // overflow: 'hidden',
    },
    '.nav-sticky .nav-container': {
      boxShadow: '0 0 25px rgba(140,152,164,.25)',
      '.button-group-link.level-1, button-group-link.level-1:visited': {
        color: 'headerActiveColor',
      },
    },
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    mx: 'auto',
    py: '20px',
    pb: ['20px', '10px', '10px', '10px', '20px', '20px'],
    // height: ['6rem', '7rem'], //prevent layout shift
  },
  logoContainer: {
    flexShrink: 0,
    mr: '60px',
  },
  desktopMenu: {
    display: [null, 'none', null, null, 'block'],
    minWidth: 'auto',
    flexGrow: 1,
    marginRight: '3px',
  },
  desktopMenuContainer: {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  mobileMenu: {
    display: [null, 'flex', null, null, 'none'],
    width: '360px',
    '& > button': {
      mr: 0,
      ml: 'auto',
    },
  },
  mobileHeaderLogo: {
    py: '12px',
    px: '16px',
  },
  headerButtons: {
    '.button-group-link.level-1, button-group-link.level-1:visited': {
      fontSize: '16px',
      color: 'gray700',
      fontWeight: 600,
      mx: '16px',
      py: '10px',
      cursor: 'pointer',
    },
    '.button-group-link.level-1:nth-of-type(-n+3)': {
      borderBottom: '1px solid',
      borderColor: 'gray200',
    },
    'a.button-group-link.level-1:nth-last-of-type(2n)': {
      borderBottom: 'none',
    },
  },
  buttonsContainer: {
    '& > div': {
      display: 'flex',
      gap: '40px',
    },
  },
  buttonsWrapper: {
    '> a, > div': {
      cursor: 'pointer',
      maxHeight: '40px',
      height: 'auto',
      py: '0 !important',
      mx: 0,
    },
    '.SubButtonsOpened': {
      cursor: 'auto',
    },
    '> a::after, a::before': {
      minHeight: '35px',
    },
  },
};
